import { useTranslation } from 'react-i18next';
import { Input } from '../../../utils/components/hoc-components';
import {
  getCommonValidators,
  VALIDATION as V,
} from '../../../utils/inputValidators';

interface DiscoveryInfoInputProps {
  readonly?: boolean;
  name?: string;
  rules?: Record<string, unknown>;
}

export function DiscoveryInfoInput({
  readonly = false,
  name = 'discoveryInfo',
  rules,
}: DiscoveryInfoInputProps) {
  const { t } = useTranslation();

  return (
    <Input
      readonly={readonly}
      name={name}
      rules={rules ?? getCommonValidators([V.MAX_LENGTH_300])}
      className="drawer__users__form__input"
      placeholder={t('ADMISSION.APPLICATION.LABELS.DISCOVERY_INFO') ?? ''}
      label={t('ADMISSION.APPLICATION.LABELS.DISCOVERY_INFO') ?? ''}
    />
  );
}
